import React from "react";
import {connect} from "react-redux";
import {Button, Image, Input, message, Modal, Space, Table, Tooltip} from "antd";
import {addItemsToSoftwarePresetGroup, searchWordpressPlugins, searchWordpressThemes} from "../../actions/domains";
import {displayErrors} from "../../libs/utils";
import {EyeOutlined} from "@ant-design/icons";
import {PiDownload} from "react-icons/pi";
import {TbUsers} from "react-icons/tb";
import {IoGitBranchOutline} from "react-icons/io5";
import {MdOutlineUpdate} from "react-icons/md";
import moment from "moment";

class AddItemToSoftwarePresetGroupModal extends React.Component {
    state = {
        loading: false,
        searching: false,
        selectedItems: [],
        searchQuery: '',
        dataList: [],
        pagination: { current: 1, pageSize: 10, showSizeChanger: true, total: 0 },
        selectedItemData: {}
    };

    closeModal() {
        this.setState({
            loading: false,
            searching: false,
            selectedItems: [],
            searchQuery: '',
            dataList: [],
            pagination: { current: 1, pageSize: 10, showSizeChanger: true, total: 0 },
            selectedItemData: {}
        });

        this.props.close();
    }

    addItemsToGroup(close = false) {
        const selectedItems = this.state.selectedItems.map(
            slug => this.state.selectedItemData[slug]
        );

        let data = {
            items: selectedItems
        };

        this.setState({ loading: true });

        this.props.addItemsToSoftwarePresetGroup(this.props.activePreset, this.props.activeGroup, data, () => {
            this.setState({ loading: false, selectedItems: [] });
            message.success('Items successfully added to the preset group!');

            if(close) {
                this.closeModal(true);
            }

            this.props.reloadPresets();

        }, (err) => {
            this.setState({ loading: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    searchThemes(query, page = null, per_page = null) {
        this.setState({ searching: true, searchQuery: query });

        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.props.searchWordpressThemes(query, page, per_page, (res) => {
            this.setState({
                dataList: res.data.themes,
                searching: false,
                pagination: {
                    current: page,
                    pageSize: per_page,
                    showSizeChanger: true,
                    total: res.data.info.results
                }
            });
        }, (err) => {
            this.setState({ searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    searchPlugins(query, page = null, per_page = null) {
        this.setState({ searching: true, searchQuery: query });

        if(page == null) {
            page = this.state.pagination.current;
            per_page = this.state.pagination.pageSize;
        }

        this.props.searchWordpressPlugins(query, page, per_page, (res) => {
            this.setState({
                dataList: res.data.plugins,
                searching: false,
                pagination: {
                    current: page,
                    pageSize: per_page,
                    showSizeChanger: true,
                    total: res.data.info.results
                }
            });
        }, (err) => {
            this.setState({ searching: false });

            if(typeof err.response !== 'undefined') {
                displayErrors(err.response.data);
            }
        });
    }

    displayScreenshots(items) {
        if (!items || Object.keys(items).length === 0) {
            return null;
        }

        const firstKey = Object.keys(items)[0];

        return (
            <Image
                src={items[firstKey].src}
                width={40}
                loading="lazy"
            />
        );
    }

    decodeHTML = (html) => {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .documentElement.textContent;
    };

    pluginsColumns = [
        { title: 'Plugin', dataIndex: 'name', render: (item, row) => {
                return <div>
                    <div>
                        <a href={'https://wordpress.org/plugins/' + row.slug + '/'} target='_blank' rel='noopener noreferrer'>{this.decodeHTML(item)}</a>
                    </div>
                    <Space style={{color: '#6c6b6b', fontSize: '12px'}}>
                        <Tooltip title='Version'><IoGitBranchOutline style={{marginBottom: '-2px', fontSize: '14px'}} /> {row.version}</Tooltip>
                        <Tooltip title='Author'>
                            <TbUsers style={{marginBottom: '-2px', fontSize: '14px'}} />
                            <a href={row.author_profile}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{color: '#6c6b6b'}} >
                                {new DOMParser().parseFromString(row.author, 'text/html').body.textContent}
                            </a>
                        </Tooltip>
                        <Tooltip title='Downloads'>
                            <PiDownload style={{marginBottom: '-2px', fontSize: '14px'}} /> {row.downloaded.toLocaleString()}
                        </Tooltip>
                        <Tooltip title='Last updated'>
                            <MdOutlineUpdate style={{marginBottom: '-2px', fontSize: '14px'}} /> {moment.utc(row.last_updated, 'YYYY-MM-DD h:mma [GMT]', true).local().format('YYYY/MM/DD')}
                        </Tooltip>
                    </Space>
                </div>;
            }},
        { title: 'Screenshots', dataIndex: 'screenshots', render: (item) => this.displayScreenshots(item)},
    ];

    themesColumns = [
        { title: 'Theme', dataIndex: 'name', render: (item, row) => {
            return <div>
                <div><a href={'https://wordpress.org/themes/' + row.slug + '/'} target='_blank' rel='noopener noreferrer'>{item}</a></div>
                <Space style={{color: '#6c6b6b', fontSize: '12px'}}>
                    <Tooltip title='Version'><IoGitBranchOutline style={{marginBottom: '-2px', fontSize: '14px'}} /> {row.version}</Tooltip>
                    <Tooltip title='Author'>
                        <TbUsers style={{marginBottom: '-2px', fontSize: '14px'}} /> {row.author}
                    </Tooltip>
                </Space>
            </div>
        }},
        { title: 'Screenshot', align: 'center', dataIndex: 'screenshot_url', render: (item) => <Image src={item} width={30} />},
        { title: '', align: 'right', dataIndex: 'preview_url', render: (item) => {
            return <a href={item} target='_blank' rel='noopener noreferrer'><Button icon={<EyeOutlined />} size='small'>Preview</Button></a>;
        }}
    ];

    render() {
        const { Search } = Input;

        let content = '';

        if(this.props.activeGroupType === 'PLUGINS') {
            content = <div>
                <Search placeholder="Search plugins" enterButton="Search" loading={this.state.searching}
                        disabled={this.state.searching} allowClear onSearch={(value) => this.searchPlugins(value)} />
                <br /><br />
                <Table
                    dataSource={this.state.dataList}
                    columns={this.pluginsColumns}
                    rowKey={(item) => item.slug}
                    pagination={this.state.pagination}
                    size='small'
                    rowSelection={{
                        selectedRowKeys: this.state.selectedItems,

                        preserveSelectedRowKeys: true,

                        onChange: (selectedRowKeys, selectedRows) => {
                            this.setState(prevState => {
                                const selectedItemData = {
                                    ...prevState.selectedItemData
                                };

                                selectedRows.forEach(item => {
                                    selectedItemData[item.slug] = {
                                        name: item.name,
                                        slug: item.slug
                                    };
                                });

                                return {
                                    selectedItems: selectedRowKeys,
                                    selectedItemData
                                };
                            });
                        }
                    }}
                    onChange={(pagination) => this.searchPlugins(this.state.searchQuery, pagination.current, pagination.pageSize)}
                    loading={this.state.searching} />
            </div>
        } else if(this.props.activeGroupType === 'THEMES') {
            content = <div>
                <Search placeholder="Search themes" enterButton="Search" loading={this.state.searching}
                        disabled={this.state.searching} allowClear onSearch={(value) => this.searchThemes(value)} />
                <br /><br />
                <Table
                    dataSource={this.state.dataList}
                    columns={this.themesColumns}
                    rowKey={(item) => item.slug}
                    pagination={this.state.pagination}
                    size='small'
                    rowSelection={{
                        selectedRowKeys: this.state.selectedItems,

                        preserveSelectedRowKeys: true,

                        onChange: (selectedRowKeys, selectedRows) => {
                            this.setState(prevState => {
                                const selectedItemData = {
                                    ...prevState.selectedItemData
                                };

                                selectedRows.forEach(item => {
                                    selectedItemData[item.slug] = {
                                        name: item.name,
                                        slug: item.slug
                                    };
                                });

                                return {
                                    selectedItems: selectedRowKeys,
                                    selectedItemData
                                };
                            });
                        }
                    }}
                    onChange={(pagination) => this.searchThemes(this.state.searchQuery, pagination.current, pagination.pageSize)}
                    loading={this.state.searching} />
            </div>
        }

        return(
            <Modal
                centered
                title={this.props.activeGroupType === 'PLUGINS' ? 'Add Plugin' : 'Add Theme'}
                open={this.props.showModal}
                onCancel={() => this.closeModal()}
                width='700px'
                footer={<div>
                    <Button disabled={this.state.loading} onClick={() => this.closeModal()}>Cancel</Button>
                    <Button disabled={this.state.loading || this.state.selectedItems.length === 0} loading={this.state.loading} onClick={() => this.addItemsToGroup()}>Add</Button>
                    <Button disabled={this.state.loading || this.state.selectedItems.length === 0} loading={this.state.loading} type='primary' onClick={() => this.addItemsToGroup(true)}>Add & Close</Button>
                </div>}
                destroyOnClose={true}>
                {content}
            </Modal>
        );
    }
}

export default connect(null, { searchWordpressPlugins, searchWordpressThemes,
    addItemsToSoftwarePresetGroup })(AddItemToSoftwarePresetGroupModal);